var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 102,
    width: 102,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m26.391045,36.507036a1.872835,1.605924 0 0 0 -1.747979,1.68622l0,37.632159a8.45897,7.253425 0 0 0 7.89712,7.788733l34.897153,0a8.490184,7.28019 0 0 0 7.928333,-7.654906l0,-37.846282a1.779193,1.525628 0 1 0 -3.527172,0l0,37.712455a4.713301,4.041576 0 0 1 -4.401161,4.255699l-34.897153,0a4.713301,4.041576 0 0 1 -4.401161,-4.255699l0,-37.712455a1.872835,1.605924 0 0 0 -1.747979,-1.605924z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "m16.348241,29.56947a1.87301,1.686135 0 0 0 1.716926,1.770442l63.869656,0a1.87301,1.686135 0 0 0 1.716926,-1.770442a1.87301,1.686135 0 0 0 -1.716926,-1.798545l-17.9809,0l0,-6.96936a4.682526,4.215339 0 0 0 -4.307924,-4.468259l-19.292008,0a4.682526,4.215339 0 0 0 -4.307924,4.468259l0,6.96936l-17.9809,0a1.87301,1.686135 0 0 0 -1.716926,1.798545zm23.162896,-8.767905a0.936505,0.843068 0 0 1 0.842855,-0.899272l19.292008,0a0.936505,0.843068 0 0 1 0.842855,0.899272l0,6.96936l-20.977717,0l0,-6.96936z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    d: "m60.179546,71.622651l0,-27.578726a1.736652,1.770256 0 1 0 -3.442837,0l0,27.578726a1.736652,1.770256 0 1 0 3.442837,0z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    d: "m43.322957,71.456006l0,-27.578761a1.73666,1.770258 0 1 0 -3.442853,0l0,27.578761a1.73666,1.770258 0 1 0 3.442853,0z",
    className: "cls-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.e339583cfd3bdabb431b0a27b09c7a1c.svg";
export { ForwardRef as ReactComponent };